export default "__VITE_PUBLIC_ASSET__f7f3fb23__"